// extracted by mini-css-extract-plugin
export default {"title":"C_-z","warning":"D_-z","sizeOptionsLegendText":"E_-z"};